/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckinTime
 */
export interface CheckinTime {
    /**
     * Time to start boarding the ship
     * @type {string}
     * @memberof CheckinTime
     */
    startDateTime?: string;
    /**
     * Time to finish boarding the ship
     * @type {string}
     * @memberof CheckinTime
     */
    endDateTime?: string;
}

/**
 * Check if a given object implements the CheckinTime interface.
 */
export function instanceOfCheckinTime(value: object): value is CheckinTime {
    return true;
}

export function CheckinTimeFromJSON(json: any): CheckinTime {
    return CheckinTimeFromJSONTyped(json, false);
}

export function CheckinTimeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckinTime {
    if (json == null) {
        return json;
    }
    return {
        
        'startDateTime': json['startDateTime'] == null ? undefined : json['startDateTime'],
        'endDateTime': json['endDateTime'] == null ? undefined : json['endDateTime'],
    };
}

export function CheckinTimeToJSON(json: any): CheckinTime {
    return CheckinTimeToJSONTyped(json, false);
}

export function CheckinTimeToJSONTyped(value?: CheckinTime | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'startDateTime': value['startDateTime'],
        'endDateTime': value['endDateTime'],
    };
}

